import React from "react";
import { useNavigate, useParams } from "react-router-dom";

const Buttonhandler = ({ SubmitANswer }) => {
  const { school_id, id, type, child_id, qtype } = useParams();
  const Navigate = useNavigate();
  const Stepback = () => {
    Navigate(`/evaluation/${school_id}/${id}/${type}/${child_id}/1`);
  };
  return (
    <div className="flex items-end justify-end max-[740px]:flex-col-reverse max-[740px]:items-center  max-[740px]:pb-20">
      <button
        onClick={() => SubmitANswer(false)}
        className="underline text-[#f79221] font-semibold text-sm mx-3 max-[740px]:w-11/12 max-[740px]:my-2"
      >
        Save later & Resume
      </button>
      {qtype == 2 ? (
        <button
          onClick={Stepback}
          className="py-2 px-3 rounded-md border-2  border-[#0005] border-solid text-sm mx-3 text-[#0008 ] font-semibold max-[740px]:w-11/12 max-[740px]:my-2"
        >
          Back to step 1
        </button>
      ) : (
        ""
      )}
      <button
        onClick={() => SubmitANswer(true)}
        className="py-2 px-7 rounded-md bg-[#f79221] border-2  border-[#f79221] border-solid text-sm mx-3 text-[white] font-semibold max-[740px]:w-11/12 max-[740px]:my-2"
      >
        Submit
      </button>
    </div>
  );
};

export default Buttonhandler;
